import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithGoogle } from '../services/authService';

interface UseGoogleSignInReturn {
  isLoading: boolean;
  error: string | null;
  handleGoogleSignIn: () => Promise<void>;
}

export const useGoogleSignIn = (): UseGoogleSignInReturn => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const handleGoogleSignIn = async () => {
    try { 
      setIsLoading(true);
      setError(null);
      await signInWithGoogle();
      navigate('/chat');
    } catch (error) {
      console.error('Error during Google sign in:', error);
      setError('Failed to sign in with Google');
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    handleGoogleSignIn
  };
};